import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function InCallIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M16.3876 8.56872L19.1477 7.01805C19.6203 6.7323 20.2351 6.88378 20.5209 7.35639C20.8066 7.829 20.6551 8.44378 20.1825 8.72953L17.4098 10.2878L18.9596 10.6697C19.4959 10.8018 19.8235 11.3437 19.6914 11.8799C19.5592 12.4161 19.0174 12.7437 18.4812 12.6116L14.5973 11.6547C14.0611 11.5225 13.7335 10.9807 13.8656 10.4445L14.8226 6.56061C14.9547 6.02437 15.4965 5.69676 16.0328 5.82889C16.569 5.96102 16.8966 6.50285 16.7645 7.03909L16.3876 8.56872Z" fill="#BCBBD0" />
			<path d="M7.32693 3.2759C6.70023 3.55363 6.07063 3.84634 5.49167 4.21882C5.49167 4.21882 0.650382 8.20878 4.4517 16.0551C8.25301 23.9015 14.0464 22.9594 14.0464 22.9594C14.9551 22.91 15.9845 22.6357 16.9044 21.9939C17.4266 21.629 17.8217 21.1412 17.9516 20.4733C18.0297 20.0701 18.0857 19.6483 17.7705 19.3036C16.7729 18.2126 15.7752 17.1209 14.7755 16.0316C14.5589 15.7966 14.341 15.7387 14.0813 15.8752C12.6506 17.3209 12.1487 17.2472 12.1487 17.2472C12.1487 17.2472 10.3576 16.9763 8.84952 14.1838C7.34143 11.3913 8.2451 10.1171 8.84183 9.87649L8.84907 9.87357C9.44338 9.63389 10.0377 9.39421 10.5315 8.95088C10.7802 8.7279 10.93 8.45935 10.8579 8.09426C10.5771 6.66512 10.2874 5.2385 10.0253 3.806C9.94986 3.39641 9.75499 3.16549 9.38137 3.08921C9.20563 3.05416 9.02738 3.02162 8.84792 3.00988C8.32332 2.97754 7.80561 3.06457 7.32693 3.2759Z" fill="#BCBBD0" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<InCallIcon fill={props.fill} />
		</div>
	);
}